import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { observer } from 'mobx-react';
import StudentPlacementResetService from '../services/StudentPlacementResetService';
import Button from '../../../core/form/Button';

class StudentPlacementResetButtonContainer extends Component {
  static propTypes = {
    studentId: PropTypes.string.isRequired,
  };

  studentPlacementResetService = new StudentPlacementResetService();
  componentWillMount() {
    this.studentPlacementResetService.init(this.props.studentId);
  }

  render() {
    return (
      <Button
        loading={this.studentPlacementResetService.submit.fetching}
        disabled={this.studentPlacementResetService.submit.fetching}
        onClick={this.studentPlacementResetService.handleReset}
        label="New Placement test"
        icon="reload"
      />
    );
  }
}

export default observer(StudentPlacementResetButtonContainer);
